import angular from 'angular';

module.exports = angular.module('common.directives.number-range', [])
.directive('type', function typeNumberRange() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      if (attrs.type !== 'numberRange' || !ngModel) return;

      var min = attrs.min;
      var max = attrs.max;

      ngModel.$parsers.push(function(value) {
        if (!value) return null;

        var floatValue = parseFloat(value);
        if (floatValue > max) value = max;
        if (floatValue < min) value = min;

        element.val(value);
        ngModel.$setViewValue(value);
        ngModel.$commitViewValue(value);

        return value;
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/number-range.js
 **/